import * as z from "zod";

/** Customs fields the catalog filters and orders on. */
export const InternationalCustomsCatalogField = z.enum([
  "hsCode",
  "customsDescription",
  "originCountry",
  "manufacturerId",
  "merchantProductId",
  "manufacturerProductId",
]);

export const InternationalCustomsCatalogRow = z.object({
  productId: z.string(),
  sourceId: z.string().nullable(),
  sku: z.string().nullable(),
  upc: z.string().nullable(),
  title: z.string(),
  hsCode: z.string().nullable(),
  originCountry: z.string().nullable(),
  customsDescription: z.string().nullable(),
  manufacturerPartNumber: z.string().nullable(),
  /** Decimal text, as stored. */
  weight: z.string().nullable(),
  weightUnit: z.string().nullable(),
  length: z.number().nullable(),
  lengthUnit: z.string().nullable(),
  width: z.number().nullable(),
  widthUnit: z.string().nullable(),
  height: z.number().nullable(),
  heightUnit: z.string().nullable(),
  manufacturer: z
    .object({ id: z.string(), name: z.string(), mid: z.string().nullable() })
    .nullable(),
  /** Of requiredFields, the ones this variant is short. */
  missingFields: z.array(InternationalCustomsCatalogField),
});

export const listInternationalCustomsCatalog = {
  name: "listInternationalCustomsCatalog" as const,
  input: z.object({
    /** nextCursor from the previous page; null starts over. */
    cursor: z.string().nullable(),
    pageSize: z.number().int().min(1).max(100),
    /** SKU or product title; narrows to the best matches. */
    search: z.string().max(200).nullable(),
    completeness: z.enum(["all", "missing", "ready"]),
    /** Count every match too, at the cost of one more catalog scan. */
    includeTotal: z.boolean(),
  }),
  output: z.object({
    /** Fields the merchant must fill, EU product identifiers included when a Redo market sells into the EU. */
    requiredFields: z.array(InternationalCustomsCatalogField),
    euProductIdentifiersRequired: z.boolean(),
    rows: z.array(InternationalCustomsCatalogRow),
    nextCursor: z.string().nullable(),
    /** Only when includeTotal was set. */
    total: z.number().optional(),
    /** Set when the search matched more variants than the catalog lists. */
    searchTruncated: z.boolean().optional(),
  }),
};
